
import Form from 'react-bootstrap/Form';
import useLentes from '../hooks/useLentes';

const Lentes = () => {

    const { graduacion, setGraduacion, usaLentes, setUsaLentes, guardar,
        mostrarGuardar, setMostrarGuardar } = useLentes();

    function mostrarInputGraduacion() {
        if ( usaLentes ) {
            return (
                <>
                    {/* <FloatingLabel
                        className='mt-3 d-flex'
                        label='Indica la graduación de tus lentes'
                    >
                        <Form.Control
                            placeholder=' '
                            value={ graduacion }
                            onChange={ e => setGraduacion( e.target.value ) }
                        />
                        <Button variant='warning'>
                            <PencilIcon/>
                        </Button>
                    </FloatingLabel> */}
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            value={ graduacion }
                            disabled={!mostrarGuardar}
                            className="form-control text-center"
                            aria-label="Indica la graduación de tus lentes"
                            placeholder="Indica la graduación de tus lentes"
                            onChange={ e => setGraduacion( e.target.value ) }
                            aria-describedby="Indica la graduación de tus lentes"
                        />
                        {!mostrarGuardar && <button className="btn btn-warning" type="button" id="Indica la graduación de tus lentes" onClick={ () => setMostrarGuardar(true)}>Editar</button>}
                    </div>

                    { mostrarGuardar && <div className="d-flex justify-content-center col-6 mx-auto mt-3">
                        <button
                            type="button"
                            onClick={ guardar }
                            className="btn btn-primary"
                        >
                            Guardar
                        </button>
                    </div>}
                </>
            )
        }
    }

    return (
        <div>

            <p className="lead text-center">
                ¿Usa lentes?
            </p>

            <Form.Check
                id = 'usa_lentes'
                type = 'checkbox'
                className = 'd-flex justify-content-center no-select'
                checked = { usaLentes }
                onChange = { e => setUsaLentes( e.target.checked ) }
                label = '&nbsp;&nbsp;Marcar en caso de usar lentes'
            />

            <div className='d-flex justify-content-center'>
                <div className='col-12 col-md-6'>
                    { mostrarInputGraduacion() }
                </div>
            </div>

            <hr className='m-5'/>
        </div>
    )
}

export default Lentes
